const images = {
  embeddLogo: require('./img/embeddLogo.png'),
}
export default images;



// WEBPACK FOOTER //
// ./src/style/images.js